import React from 'react'
import { shallow } from 'enzyme'

import EtranLayout  from '../EtranLayout'
import EtranLanding  from '../EtranLanding'

describe('EtranLayout', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      loanId:15262,
      paycheck_protection: true,
      etran_via_api: true,
    }
    wrapper = shallow(<EtranLayout {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return an <EditProduct />', () => {
      const componentProps = wrapper.props();

      expect(wrapper.find(EtranLanding)).toHaveLength(1)
    })
  })
})
